import { jsx as _jsx } from "react/jsx-runtime";
import Image from '@marketing/components/sections/non_product/Media/Image';
function ProductImage(_a) {
    var imageData = _a.imageData;
    return _jsx(Image, { imageData: imageData, className: "w-40 h-auto" });
}
export default ProductImage;
